import { CHATWOOT_BASE, authHeaders } from '@/api/chatwoot'
import { mapRawConversation, type RawChatwootConversation } from '@/services/chatwootRealtimeTranslator'
import type { Conversation } from '@/types/dashboard'

const ACCOUNT_PATH = `${CHATWOOT_BASE}/api/v1/accounts/3`

// Fase 6 do plano de tempo real (docs/planos/PLANO-REALTIME-ACTIONCABLE.md) —
// busca pontual de UMA conversa, usada só quando chega um evento em tempo
// real (message.created/updated, conversation.updated/assignee.changed) pra
// um conversation_id ainda desconhecido localmente (conversa nova de
// verdade — o poll ainda não trouxe ela). Diferente de messagesService.ts
// (que usa o token de serviço via n8n porque o dashboard lista conversas de
// QUALQUER time/inbox): esses eventos só chegam pelo WebSocket pra quem já é
// membro do inbox daquela conversa no Chatwoot (ver "Limitação real
// descoberta" no plano) — então o token pessoal do agente já tem acesso
// garantido a essa conversa específica, sem o 401 documentado ali.
export async function fetchConversationById(convId: number, token: string): Promise<Conversation | null> {
  try {
    const res = await fetch(`${ACCOUNT_PATH}/conversations/${convId}`, { headers: authHeaders(token) })
    if (!res.ok) return null
    const raw = (await res.json()) as RawChatwootConversation
    if (typeof raw.id !== 'number') return null
    return mapRawConversation(raw)
  } catch {
    return null
  }
}
